/**
 * v1 계약 유형 제목(=v1 create 라우트 name, 모두싸인 템플릿 제목과 동일) → v2 create 라우트 name 매핑.
 *
 * 왜 있는가:
 * - v1 ContractItem.vue는 클릭 시 this.$router.push({name: this.title})로 이동한다. title은
 *   ContractTypeList(V1/V2 공용) 화면이 템플릿 목록에서 뽑아온 모두싸인 템플릿 제목이며, 동시에
 *   router.enums.js에 등록된 v1 create 라우트의 name과 동일하다(router.enums.js 주석 참조:
 *   "name 값을 https://app.modusign.co.kr/templates 의 이름과 일치 시켜야 함").
 * - v2는 router.enums.js(v1 소유 파일)를 건드릴 수 없으므로, v2 create 라우트 name은 이 파일에서
 *   별도로 정의한다. 매핑 규칙: v1 title + 'V2' 접미사. 충돌 걱정 없이 기계적으로 만들 수 있고,
 *   어느 화면이 v1이고 어느 화면이 v2인지 라우트 name만 보고 바로 알 수 있어 채택했다.
 * - 이번 라운드는 물품매매V4(MulpumV6) 1건만 v2 create 화면이 존재한다. 나머지 4종(장비 등)은
 *   아직 v2 create 화면이 없으므로, 이 맵에 없는 title은 v1 라우트 name으로 폴백해야 한다
 *   (ContractItemV2.vue의 resolveContractCreateRouteName 참조) — 그렇지 않으면 카드 클릭이
 *   존재하지 않는 라우트로 이동해 조용히 아무 반응도 없는 회귀가 된다.
 */
export const CONTRACT_TITLE_TO_V2_CREATE_ROUTE_NAME = {
  '덴티움 물품 매매 계약서': '덴티움 물품 매매 계약서V2',
  // 2026-08-15: v2 창구 나머지 4종 — contracts-api 매퍼·프릭스 템플릿(QA/운영)까지 준비 완료된
  // 유형들이다. 제목은 모두싸인 템플릿 제목(=v1 create 라우트 name)과 정확히 일치해야 한다.
  'BNK역구매': 'BNK역구매V2',
  '신협역구매': '신협역구매V2',
  'Chair 제품설치 확인서 수정 (Rev.3)': 'Chair 제품설치 확인서 수정 (Rev.3)V2',
  'Dentium-CBCT-설치완료 확인서 (Rev.5)': 'Dentium-CBCT-설치완료 확인서 (Rev.5)V2',
  // 2026-08-15: 플라즈맵 ACTILINK — 휴면이나 폐기 미결정이라 v2 이관(모두싸인 발행 유지)
  'ACTILINK 정기 렌탈서비스 약정서': 'ACTILINK 정기 렌탈서비스 약정서V2',
};

/**
 * v1 계약서 제목(title)으로 v2 create 라우트 name을 찾는다.
 * 맵에 없으면 title(=v1 라우트 name)을 그대로 돌려줘 v1 create 화면으로 폴백한다.
 */
export function resolveContractCreateRouteName(title) {
  return CONTRACT_TITLE_TO_V2_CREATE_ROUTE_NAME[title] || title;
}
